/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  app_name: "Expofin Platform",
  production: true,
  api_path: 'https://app.expofin.eu',
  // Auth backend that issues the refresh cookie (refresh/logout); login goes through Hasura.
  auth_path: 'https://app.expofin.eu',

  hasura_uri: 'https://app.expofin.eu/hasura/v1/graphql',

  hasura_subscriptions_uri: 'wss://app.expofin.eu/hasura/v1/graphql',
  models_url: 'https://app.expofin.eu/api/models',
  privacy_url: 'https://app.expofin.eu/api/privacy.pdf',
  terms_url: 'https://app.expofin.eu/api/terms.pdf',
  support_email: 'dev@im-tech.it',
  default_user: 'a5505b95-4519-4fb5-a109-9d9607befa40',
  default_impianto: 'd8d1a3f8-d9db-4389-950c-b3d582882778',
  default_device: '06365223-75d4-d659-9eb9-2dfc04ab26b3',
  default_device_type: 'PV',
};
